import React from "react";
import Button from "react-bootstrap/Button";
import { BsArrowRepeat } from "react-icons/bs";
import "./index.css";

interface AuthButtonProps {
  isLoading: boolean;
  disable: boolean;
  className?: string;
  [x: string]: any;
}

export default function AuthButton(props: AuthButtonProps) {
  const { isLoading, disable, ...rest } = props;
  return (
    <Button disabled={disable || isLoading} className="AuthButton" {...rest}>
      {isLoading && <BsArrowRepeat className="spinning" />}
      {props.children}
    </Button>
  );
}
